export const CITY = '/city/'
export const CITY_ALL = `${CITY}all`
